<div class="modal-content">
  <div class="header">
    <h4 class="title" id="exampleModalLabel1">Tareas</h4>

    <div class="searchbar">
      <input
        class="search_input"
        type="text"
        [(ngModel)]="search"
        placeholder="Filtrar..."
      />
      <button class="search_icon" (click)="filter()">
        <i class="fas fa-search"></i>
      </button>
    </div>
    <mat-icon class="close" (click)="close()">close</mat-icon>
  </div>

  <ng-container *ngIf="taskSelected.length > 0">
    <div class="container">
      <div class="row">
        <div class="col-4 taskcol" *ngFor="let task of taskSelected">
          <task-case-card
            class="selected"
            (click)="removeFromSelected(task)"
            [task]="task"
          ></task-case-card>
        </div>
      </div>
    </div>
    <div class="btn-c">
      <button
        (click)="addTasks()"
        mat-fab
        color="warn"
        aria-label="Example icon button with a home icon"
      >
        <mat-icon>check</mat-icon>
      </button>
    </div>

    <div class="divisor"></div>
  </ng-container>
  <div class="container">
    <div class="row">
      <div class="col-12" *ngIf="tasks?.length === 0" style="padding: 15px">
        <b>Sin tareas para agregar</b>
      </div>
      <div class="col-4 taskcol" *ngFor="let task of tasks">
        <task-case-card
          (click)="addToSelected(task)"
          [task]="task"
        ></task-case-card>
      </div>
    </div>
  </div>
</div>
